
import React, { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import InvestmentApplicationForm from './components/InvestmentApplicationForm';
import InvestmentBenefits from './components/InvestmentBenefits';
import InvestmentProcess from './components/InvestmentProcess';
import InvestmentFAQ from './components/InvestmentFAQ';

const StartInvestingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-emerald-50 to-teal-50 py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/8d20b4094798275ef7cde7a772943cf1.jpg')`
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Start Your Glamping Investment Journey
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              Join the growing outdoor hospitality market with OED Glamping Retreat Developments. 
              Our proven investment model delivers sustainable returns while creating unforgettable experiences.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="text-3xl font-bold text-emerald-600">15-25%</div>
                <div className="text-gray-600">Expected Annual Returns</div>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="text-3xl font-bold text-emerald-600">$50K</div>
                <div className="text-gray-600">Minimum Investment</div>
              </div>
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="text-3xl font-bold text-emerald-600">3-5 Years</div>
                <div className="text-gray-600">Investment Timeline</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Investment Benefits */}
      <InvestmentBenefits />

      {/* Investment Process */}
      <InvestmentProcess />

      {/* Application Form */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Ready to Invest?
            </h2>
            <p className="text-lg text-gray-600">
              Complete our investment application to get started. Our team will review your application 
              and schedule a consultation within 48 hours.
            </p>
          </div>
          <InvestmentApplicationForm />
        </div>
      </section>

      {/* FAQ Section */}
      <InvestmentFAQ />

      <Footer />
    </div>
  );
};

export default StartInvestingPage;
